import React, { Component } from 'react';
import { Col, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

class Ananmesis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cause: "",
            reasonForConsultation: "",
            currentIllness: "",
            load: false,
        };
    }
    /*componentDidMount() {
        this.setState({ load: true }, ()=>{
          this.props.loadAnamesis().then((load) => {
            this.setState({ load: load },()=>{
                console.log("cargar anamesis");
            });
          }).catch((error)=>{
            console.log(error)
          });
        })    
    }*/

    render() {
        return (
        <Col>
            <div className="form" style={{ flex: 1, flexDirection: 'column', marginBottom: 100 }}>
                <div className="card__title">
                    <h5 className="bold-text">Anamnesis</h5>
                </div>
                <div className="form__form-group" style={{ margin: 10, }}>
                        <span className="form__form-group-label">Causa de Ingreso</span>
                        <div className="form__form-group-field">
                        <TextField
                            id="select-cause-of-admission"
                            className=" medical-material-form__field"
                            style={{ width: '18%' }}
                            select
                            label=""
                            value={this.props.anamesis.cause}
                            onChange={(e) => {
                                this.props.handlerSelectCauseOfAdmission(e.target.value)
                            }}                       
                        >
                            <MenuItem value={'Enfermedad general'}> Enfermedad general </MenuItem>
                            <MenuItem value={'Enfermedad professional'}> Enfermedad professional </MenuItem>
                            <MenuItem value={'Evento catastrofico'}> Evento catastrofico </MenuItem>
                            <MenuItem value={'Accidente de trabajo'}>  Accidente de trabajo </MenuItem>
                            <MenuItem value={'Accidente de transito'}> Accidente de transito </MenuItem>
                            <MenuItem value={'Accidente ofidico'}>  Accidente ofidico </MenuItem>
                            <MenuItem value={'Otro tipo de accidente'}> Otro tipo de accidente </MenuItem>                                                      
                            <MenuItem value={'Lesion auto infligida'}> Lesion auto infligida </MenuItem>
                            <MenuItem value={'Lesion por agresion'}> Lesion por agresion </MenuItem>                                                       
                            <MenuItem value={'Sospecha abuso sexual'}> Sospecha abuso sexual </MenuItem>
                            <MenuItem value={'Sospecha maltrato emocional'}> Sospecha maltrato emocional </MenuItem>
                            <MenuItem value={'Sospecha maltrato fisico'}> Sospecha maltrato fisico </MenuItem>
                            <MenuItem value={'Sospecha violencia sexual'}> Sospecha violencia sexual </MenuItem>
                            <MenuItem value={'Otra'}> Otra </MenuItem>
                        </TextField>
                        </div>
                    </div>
                <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>                   
                    <div className="form__form-group" style={{ margin: 10 }}>
                        <span className="form__form-group-label">Motivo de Consulta</span>
                        <div className="form__form-group-field">
                            <Field
                                name="textarea-reason-for-consultation"
                                component="textarea"
                                type="text"
                                value={this.props.anamesis.reasonForConsultation}
                                onChange={(e) => {
                                    this.props.handlerReasonForConsultation(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form__form-group" style={{ margin: 10 }}>
                        <span className="form__form-group-label">Enfermedad Actual</span>
                        <div className="form__form-group-field">
                            <Field
                                name="textarea-current-illness"
                                component="textarea"
                                type="text"
                                value={this.props.anamesis.currentIllness}
                                onChange={(e) => {
                                    this.props.handlerCurrentIllness(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Col>);
    }
}

export default reduxForm({
    form: `ananmesis-form`, // a unique identifier for this form
})(withTranslation('common')(Ananmesis));